<app-rad-base-modal
#radBaseModal
[identifier]="modalType"
    [closable]="closable"
    [closeButtonText]="closeButtonText" 
    [confirmButtonText]="confirmButtonText"
    [newButtonText]="newButtonText" 
    [disableConfirmButton]="disableConfirmButton"
    [showNewButton]="isResourceCreatable"
    [modalZIndex]="999"
    modalHeight="calc(100vh - 252px)"
    modalWidth="calc(100vw - 252px)"
    contentMaxHeight="calc(80vh - 160px)"
    contentMarginTop="0px"
    [titleInfoPopoverContent]="titleInfoPopoverContent"
    [title]="chooserTitle"
>
   <app-resource-chooser #chooserSingleSelect 
        [title]="chooserTitle"
        [searchPlaceHolderText]="chooserSearchPlaceHolderText"
        [titleToolTip]="chooserTitleTooltip" 
        [rowSelection]="rowSelection" 
        [gridOptions]="gridOptions"
        [chooserServerSideDataParams]="chooserServerSideParams" 
        [hasMatcher]="hasMatcher"
        [initiallySelectedItems]="initiallySelectedItems"
        [resourceType]="resourceType"
        [trackLibraryPreps]="trackLibraryPreps"
        (itemsSelected)="chooserItemsSelected($event)" 
        [debounceTime]="debounceTimeInMs.toString()"
        [newlyCreatedResourceId]="newlyCreatedResourceId"
        [tableId]="tableId"
        [initialColumnFilter]="initialColumnFilter">
    </app-resource-chooser>
</app-rad-base-modal>
